export default "__VITE_ASSET__DqEgp0B5__"